
import React, { useEffect, useState } from "react";
import "../style/DepartmentPage.css";

import welding from "../assets/welding.png";
import manufacturing from "../assets/manufature.png";
import tyre from "../assets/tyrework.png";
import paint from "../assets/paint.png";

const departments = [
  {
    title: "Manufacturing Department",
    description:
      "High-precision manufacturing facility equipped with modern machinery and skilled professionals.",
    image: manufacturing,
  },
  {
    title: "Spare Parts Department",
    description:
      "Complete range of genuine and OEM spare parts ensuring reliability and fast delivery.",
    image: paint,
  },
  {
    title: "Welding & Fabrication",
    description:
      "Expert welding and metal fabrication services for heavy machinery and structural works.",
    image: welding,
  },
  {
    title: "Tyre Work Department",
    description:
      "Professional tyre repair, replacement and alignment services for heavy equipment.",
    image: tyre,
  },
];

export default function DepartmentPage() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % departments.length);
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dept-wrapper" id="departments">
      <div
        className="dept-slider"
        style={{
          transform: `translateY(-${activeIndex * 100}vh)`,
          height: `${departments.length * 100}vh`,
        }}
      >
        {departments.map((dept, index) => (
          <section
            key={index}
            className="dept-slide"
            style={{ backgroundImage: `url(${dept.image})` }}
          >
            <div className="dept-overlay">
              <h1>{dept.title}</h1>
              <p>{dept.description}</p>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
